export default "__VITE_ASSET__QGSJSK5G__"